const btnForgotPassword = {
  text: 'Resetar Senha'
};

export default btnForgotPassword;
